import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import { ConfirmationDialog } from "components";
import { RoleProps } from "../store/actionType";
import { deleteRole } from "../store/action";

interface CategoryProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  roleData: RoleProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CategoryProps;
const HandleDeleteRole: React.FC<Props> = ({
  closeModal,
  roleData,
  onDeleteRole,
}) => {
  const [error,setError] = useState("")
  const roleState = useSelector(
    (state: any) => state.roles.genericRoleState
  );
  
  const handleDeletePackage = async (e: FormEvent) => {
    e.preventDefault();
    onDeleteRole(roleData.id.toString());
    closeModal(false)
  };
   useEffect(() => {
      setError(roleState?.error);
    }, [roleState?.error]);
  return (
    <>
      <ConfirmationDialog
        title={`Delete ${roleData.name}`}
        message={"Are you sure you want to delete this role?"}
        onConfirm={handleDeletePackage}
        onCancel={closeModal}
        error={error}
      />
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteRole: (id: string) => dispatch(deleteRole(id)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteRole);
